






































import { Vue, Component, Prop, PropSync, Provide } from 'vue-property-decorator';

import Layout from '@/layouts/Default.vue';
import TitlePage from '@/components/Title.vue';
import CalendarFilter from '../CalendarFilter.vue';
import CalendarAdmin from '@/components/calendar/CalendarAdmin.vue'
import CalendarRepository from '@/components/calendar/CalendarRepository.vue';

import { SelectItem } from '@/components/select/types';

@Component({
    components: {
        Layout,
        TitlePage,
        CalendarFilter,
        CalendarRepository,
        CalendarAdmin,
    },
})
export default class CalendarAdminPage extends Vue {
    @PropSync('doctorId') doctorModel!: number;
    @Prop({ default: () =>  [] }) clinics!: SelectItem[];
    @Prop({ default: () =>  [] }) specializations!: SelectItem[];
    @Provide() hasActions = true;
}
